import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Textfield, Form } from '@scentregroup/ui'
import style from './index.module.scss'

class Search extends Component {
  constructor(props) {
    super(props)

    this.searchInput = React.createRef()

    this.state = {
      placeholder: this.props.placeholder,
      searchQuery: this.props.searchQuery,
    }
  }

  handleSearchString = event => {
    this.setState({ searchQuery: event.target.value })
  }

  dispatchSearch = event => {
    event.preventDefault()
    this.searchInput.blur()
    const { buildUrl } = this.props
    const { searchQuery } = this.state
    if (buildUrl) {
      this.props.history.push(buildUrl({ search_query: searchQuery }))
    } else {
      this.props.history.push(`/products?search_query=${searchQuery}`)
    }
  }

  render() {
    const { searchQuery, placeholder } = this.state

    return (
      <Fragment>
        <Form
          className={this.props.className}
          action="#" /* no-op but makes iOS use 'SEARCH' as return key type */
          onSubmit={this.dispatchSearch}
        >
          <Textfield
            classNames={{
              field: style.searchField,
              wrapper: style.searchWrapper,
            }}
            maxLength={24}
            value={searchQuery}
            placeholder={placeholder}
            type={'search'}
            innerRef={ref => (this.searchInput = ref)}
            ariaLabel={'Search products'}
            onChange={this.handleSearchString}
          />
        </Form>
      </Fragment>
    )
  }
}

Search.propTypes = {
  placeholder: PropTypes.string,
  searchQuery: PropTypes.string,
  className: PropTypes.string,
  buildUrl: PropTypes.func,
  history: PropTypes.object.isRequired,
}

export default Search
